import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../auth';

/**
 * ProtectedRoute Component
 * Wraps routes that require authentication
 * Redirects to gatekeeper if not authenticated
 */
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/gatekeeper" replace />;
  }

  return children;
};

export default ProtectedRoute;
